export default "__VITE_ASSET__CFr11kr4__"